import { createSlice } from "@reduxjs/toolkit";

const initialWorkingState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  workingForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const workingSlice = createSlice({
  name: "working",
  initialState: initialWorkingState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    workingFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    workingAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    workingCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.working.push(action.payload.working);
    },
    workingDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.working.filter(el => el.working_id !== action.payload.id);
    },
    getWorking: (state, action) => {
      state.actionsLoading = false;
      state.workingForEdit = action.payload.workingForEdit;
      state.error = null;
    },
    // updateProduct
    workingUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.working = state.entities.working.map(entity => {
        if (entity.working_id === action.payload.working.working_id) {
          return action.payload.working;
        }
        return entity;
      });
    },
  },
});
